import axios from "../libs/api.request.js";
// 帐单列表
export const memberDeal = params => {
    return axios.request({
      url: "pc/memberDeal",
      method: "get",
      params: params
    });
  };


// WEBPACK FOOTER //
// ./src/api/billing.js